<template>
  <div style="width: 100%">
    <swiper v-if="banner.length" ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="(item, index) in banner" :key="index">
        <a :href="item.url" target="_blank">
          <img :src="item.img" class="swiperImg"  alt="" />
        </a>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    
    <div v-if="hot.length" class="recommend pt60">
      <div class="flex_r">
        <svgIcon name='love'  class="f32" />
        <div class="title f32 line44 fw600 marginl12">我的推荐</div>
      </div> 
      <div class="flex_r_start pt36">
        <div @click="$router.push('/info/'+hot[0].id)" class="first">
          <img :src="hot[0].img" alt="">
        </div>
        <myVideo :videoArr='hot.slice(1,3)' />
      </div>
    </div>
    <div v-for="(item,index) in tonglan" :key="index" class="mainBanner">
      <a :href="item.url" target="_blank"><img :src="item.img" alt=""></a>
      <p>广告</p>
    </div>
    <div class="flex_r_start">
      <div class="homeList">
        <column :videoArr='videos' title="视频专栏" />
        <column :videoArr='audios' title="音频专栏" />
        <column :videoArr='txts' title="文稿专栏" />
      </div>
      <div v-if="rank.length" class="rank flex0 pt60">
        <div class="flex_r">
          <svgIcon name='rank' class="f36 line44" />
          <p class="rankTitle line44 marginl12 f32 fw600">排行榜</p>
        </div>
        <div class="rankList flex_c">
          <div v-for='(item,index) in rank' :key="index" class="rankItem flex_r_start">
            <div :class="[index<3&&'active']" class="rankNum">{{index+1}}</div>
            <div @click="$router.push({name:'info',params:{infoid:item.id}})" class="rankContent  cursor">{{item.title}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "def",
  components: { swiper, swiperSlide },
  data() {
    return {
      swiperOptions: {
        pagination: { 
          el: ".swiper-pagination",
        },
        loop : true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        },
      },
      audios: [],
      videos: [],
      txts: [],
      hot: [],
      banner: [],
      tonglan: [],
      rank: [],
    };
  },
  mounted() {
    this.home();
  },
  methods: {
    async home(){
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
        try{
          let data = await this.$http.get(this.$api.home);
          this.banner = data.data.banner || [];
          this.hot = data.data.hot || [];
          this.tonglan = data.data.tonglan || [];
          this.rank = data.data.rank || [];

          this.videos = data.data.videos|| [];
          this.audios = data.data.audios|| [];
          this.txts = data.data.txts;
          loading.close();
        }catch(e){
          loading.close();
          throw new Error(e);
        }
    }
  },
};
</script>
<style lang="less" scoped>
.swiper-container {
  // --swiper-theme-color: #ff6600;
  --swiper-pagination-color: #ffffff; /* 两种都可以 */
  --swiper-pagination-bullet-width: 20px;
  --swiper-pagination-bullet-height: 6px;
  
}
/deep/.swiper-pagination-bullet {
  width: 20px;
  height: 6px;
    border-radius: 0px;
  }
/deep/.swiper-pagination-bullet-active {
  background: white;
  border-radius: 0px;
}
.swiperImg {
  width: 1200px;
  height: 510px;
}
.rank{
  width: 284px;
  margin-left: 16px;
}
.recommend{
  .first{
    width: 584px;
    height: 304px;
    margin-right: 16px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.homeList{
  width: 892px;
}
.rankList{
  margin-top: 36px;
  .rankItem{
    width: 284px;
    margin-left: 2px;
    padding-bottom: 24px;
    .rankNum{
      font-size: 16px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      margin-top: 2px;
      &.active{
        color: white;
        background: #AD2729;
      }
    }
    .rankContent{
      font-size: 18px;
      line-height: 25px;
      font-weight: bold;
      width: 100%;
      margin-left: 14px;
      word-break: break-all;
      word-wrap: break-word;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>